/* istanbul ignore file */
import PropTypes from 'prop-types';

export default {
  automationKey: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
